import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const webPractik = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img1.png',
            crewItemTitle: 'Александр Букуров',
            crewItemSubtitle: 'менеджер проекта',
        },
        {
            crewItemImg: '/images/svg/skolkovo/ace-ventura.jpg',
            crewItemTitle: 'Иван Поддубный',
            crewItemSubtitle: 'руководитель группы разработки',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Мария Лапиева',
            crewItemSubtitle: 'старший frontend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Пётр Клёнкин',
            crewItemSubtitle: 'backend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Сергей Буланов',
            crewItemSubtitle: 'backend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Антон Сербин',
            crewItemSubtitle: 'backend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Алина Климец',
            crewItemSubtitle: 'контент-менеджер',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Николай Цай',
            crewItemSubtitle: 'старший дизайнер',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Анна Сластён',
            crewItemSubtitle: 'дизайнер',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Дмитрий Потатурин',
            crewItemSubtitle: 'дизайнер',
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1.5}>
                <FullWrapper className="zkhfoundation-team">
                    <CommonTitle>Команда</CommonTitle>
                    <CrewContainer container={webPractik} />
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default Team;
